import * as React from 'react';
import styled from 'react-emotion';

const ModalWrapper = styled('div')`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: visible;
`;
const Backdrop = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
`;
const ModalBody = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 80vw;
  height: 80vh;
  padding: 2rem;
  background-color: #fff;
  border: 2px solid #444;
  border-radius: 12px;
  box-shadow: 1px 2px 1px 1px #444;
  z-index: 10;
`;

const Modal = ({
  children,
  disableBackdrop,
  onToggleModal,
}: {
  children?: React.ReactNode | React.ReactNode[];
  disableBackdrop?: boolean;
  onToggleModal?: () => void;
}) => (
  <ModalWrapper>
    <ModalBody>{children}</ModalBody>
    <Backdrop onClick={!disableBackdrop ? onToggleModal : undefined} />
  </ModalWrapper>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.tsx